module.exports = __webpack_public_path__ + "static/media/coin.04d98014.png";